import {
    Condition,
    TreatmentModel
} from "../../home/components/treatment-management/treatment.types";
import {SelectedSurface} from "../tools/surface-selector/surface.selector.types";
import {ConditionInternalIDs} from "./tooth.customize.types";
import {InterventionModel} from "../../patient/interventions/intervention.types";

export const upperLJawIDs:string[] = ["18","17","16","15","14","13","12","11"];
export const upperRJawIDS:string[] = ["21","22","23","24","25","26","27","28"];
export const lowerLJawIDs:string[] = ["48","47","46","45","44","43","42","41"];
export const lowerRJawIDs:string[] = ["31","32","33","34","35","36","37","38"];

export function getAllIDsArray():string[] {
    return upperLJawIDs.concat(upperRJawIDS, lowerRJawIDs, lowerLJawIDs);
}

export enum ConditionStatus{
    IDENTIFIED="IDENTIFIED",
    IN_WORK="IN_WORK",
    RESOLVED="RESOLVED",
    INACTIVE="INACTIVE",
    WONT_FIX="WONT_FIX",
    APPLIED="APPLIED"
}

export enum ZLayerIndex{
    ROOT = 1,
    ROOT_OVERLAY,
    CROWN   ,
    CROWN_OVERLAY,
    CROWN_SURFACE,
    TOOTH_OVERLAY ,
    ICONS
}

export class GLayer {
    constructor(public graphic:String, public classes:string, public zIndex:ZLayerIndex){}
}

export class ToothDTO {
        id: string;
        toothBlock: number;
        toothOffset: number;
        milkyTooth: boolean = false;
        nerveDead: boolean = false;
        closedGap: boolean = false;
        partOfABridge: boolean = false;
        missing: boolean = false;
        mouth: string;
        surfaceSelection:SelectedSurface[]; // This is only available on UI side
}

export class TeethLocalization {
        mesial: boolean;
        middleY: boolean;
        middleZ: boolean;
        middleCrownX: boolean;
        distal: boolean;
        lingual: boolean;
        vestibularBucal: boolean;
        crown: boolean;
        nerve: boolean;
        root: boolean;
        incisalOclusal: boolean;
        cervicalCrown: boolean;
        cervicalRoot: boolean;
        middleRoot: boolean;
        apical: boolean;
        fullMouth: boolean;
}

export interface ConditionDTO{
    getId(): string;
    getCondition(): Condition;
    getCreatedOn():  any;
    getCreatedBy(): string;
    getUpdatedOn(): any;
    getUpdatedBy(): string;
    getStomaConditionStatus():ConditionStatus;
    getDoctorRoleId():string;
    getTeethLocalization(): TeethLocalization;
}

export class ConditionDToToStore {
    private conditionId: string;
    toothId: string;
    teethLocalization: TeethLocalization;
    stomaConditionStatus: ConditionStatus;
    toothBlock: number;
    toothOffset: number;
    doctorRoleId: string;

    constructor(obj:any) {
        this.conditionId = obj.conditionId;
        this.toothId = obj.toothId;
        this.teethLocalization = obj.teethLocalization;
        this.stomaConditionStatus = obj.stomaConditionStatus;
        this.toothBlock = obj.toothBlock;
        this.toothOffset = obj.toothOffset;
        this.doctorRoleId = obj.doctorRoleId;
    }

    getConditionId():string {return this.conditionId;}
    setConditionId(id:string):void {this.conditionId=id}
}

export class ToothConditionDTO extends ConditionDToToStore implements ConditionDTO{
    id: string;
    condition: Condition;
    createdOn:  any;
    createdBy: string;
    updatedOn: any;
    updatedBy: string;
    constructor(obj:any) {
        super(obj);
        this.id = obj.id;
        this.condition = new Condition(obj.condition);
        this.createdOn = obj.createdOn;
        this.createdBy = obj.createdBy;
        this.updatedOn = obj.updatedOn;
        this.updatedBy = obj.updatedBy;
    }

    getId(): string {return this.id;}
    getCondition(): Condition {return this.condition;}
    getCreatedOn():  any {return this.createdOn;}
    getCreatedBy(): string {return this.createdBy;}
    getUpdatedOn(): any {return this.updatedOn;}
    getUpdatedBy(): string {return this.updatedBy;}
    getStomaConditionStatus():ConditionStatus {return this.stomaConditionStatus;}
    getDoctorRoleId():string {return this.doctorRoleId;}
    getTeethLocalization(): TeethLocalization {return this.teethLocalization;};
}

export class MouthConditionDToToStore {
    mouthId: string;
    conditionId: string;
    doctorRoleId: string;
    stomaConditionStatus: ConditionStatus;
    mouthLocalization: ToothSelectionMode;
    range:string;

    constructor(obj:any) {
        this.mouthId = obj.mouthId;
        this.conditionId = obj.conditionId;
        this.doctorRoleId = obj.doctorRoleId;
        this.stomaConditionStatus = obj.stomaConditionStatus;
        this.mouthLocalization = obj.mouthLocalization;
        this.range = obj.range;
    }

    getConditionId():string {return this.conditionId;}
    setConditionId(id:string):void {this.conditionId=id}
}


export class MouthConditionDTO extends MouthConditionDToToStore implements ConditionDTO{
    id: string;
    condition: Condition;
    createdOn:  any;
    createdBy: string;
    updatedOn: any;
    updatedBy: string;

    constructor(obj:any) {
        super(obj);
        this.id = obj.id;
        this.condition = new Condition(obj.condition);
        this.createdOn = obj.createdOn;
        this.createdBy = obj.createdBy;
        this.updatedOn = obj.updatedOn;
        this.updatedBy = obj.updatedBy;
    }

    getId(): string {return this.id;}
    getCondition(): Condition {return this.condition;}
    getCreatedOn():  any {return this.createdOn;}
    getCreatedBy(): string {return this.createdBy;}
    getUpdatedOn(): any {return this.updatedOn;}
    getUpdatedBy(): string {return this.updatedBy;}
    getStomaConditionStatus():ConditionStatus {return this.stomaConditionStatus;}
    getDoctorRoleId():string {return this.doctorRoleId;}
    getTeethLocalization(): TeethLocalization {return null};
}


export class MedicalStatusDTO{
    teethMedicalStatusDTOS: ToothConditionResponseDTO[];
    mouthMedicalStatusDTO: MouthConditionResponseDTO;
}

export class ToothConditionResponseDTO {
    teethDTO:ToothDTO;
    toothConditionResponseDTO: ToothConditionDTO[]
}

export class MouthConditionResponseDTO {
    mouthConditionResponseDTO: MouthConditionDTO[]
}

export class ToothDetails{
    toothConditionResponse: ToothConditionResponseDTO;
    mouthConditions: MouthConditionDTO[];
    treatments: ToothConditionDTO[];
}

/** To be used to flatten all tooth problems **/
export class ToothConditionResponse {
    teethDTO:ToothDTO;
    toothConditionResponseDTO: ToothConditionDTO
}

export function isUpperJawID(id:string) {
    return parseInt(id) < 30;
}

export function isLeftSideJawID(toothID:string) {
    const id = parseInt(toothID);
    return (id >= 11 && id <= 18) || (id >= 41 && id <= 48);
}

export function getTeethDTOFromID(id:string):ToothDTO{
    const block = parseInt(id.slice(0,1));
    const offset = parseInt(id.slice(1,2));
    return getTeethDTO(block,offset);
}

export function getTeethDTO(block:number, offset:number):ToothDTO {
    const tooth = new ToothDTO();
    tooth.toothBlock = block;
    tooth.toothOffset = offset;
    return tooth;
}

export function getLocalizationDTO():TeethLocalization {
    return {
        mesial: false,
        middleY: false,
        middleZ: false,
        middleCrownX: false,
        distal: false,
        lingual: false,
        vestibularBucal: false,
        crown: false,
        nerve: false,
        root: false,
        incisalOclusal: false,
        cervicalCrown: false,
        cervicalRoot: false,
        middleRoot: false,
        apical: false,
        fullMouth: false
    }
}

export function getNewCondition(): Condition{
    return new Condition({
        id : "",
        internalId :  ConditionInternalIDs.NOT_ASSIGNED,
        summary : "",
        category: "",
        description : "",
        icon:"",
        isDeactivated: false,
        clinicId: "",
        disciplineId: "",
    });
}

export function getNewConditionDto():ToothConditionDTO {
    const dto = new ToothConditionDTO({
        id: "",
        teethLocalization : getLocalizationDTO(),
        stomaConditionStatus : ConditionStatus.IDENTIFIED,
        condition : getNewCondition(),
        toothId : "",
        doctorRoleId: "",
    });
    return dto;
}

export function conditionDtoTOBECondition(conditionDto:ToothConditionDTO):ConditionDToToStore {
    const dto =  new ConditionDToToStore(conditionDto);
    dto.teethLocalization = conditionDto.teethLocalization;
    dto.stomaConditionStatus = conditionDto.stomaConditionStatus;
    dto.toothId = conditionDto.toothId;
    dto.doctorRoleId = conditionDto.doctorRoleId;
    dto.setConditionId(conditionDto.condition.id);
    return dto;
}

export function getNewToothConditionResponseDTO(teethDTO:ToothDTO): ToothConditionResponseDTO{
    return {
        teethDTO: teethDTO,
        toothConditionResponseDTO: []
    }
}

export function getConditionOutOfTreatmentDefinition(treatment:TreatmentModel):Condition{

    var condition:Condition = Condition.getInstance();
    condition.setID(treatment.getID());
    condition.setInternalID(treatment.getInternalID()?treatment.getInternalID():ConditionInternalIDs.NOT_ASSIGNED);
    condition.setSummary(treatment.getSummary());
    condition.setCategory(treatment.getCategory());
    condition.setDescription(treatment.getDescription());
    condition.setIcon(treatment.getIcon());
    condition.setDisabled(treatment.isDisabled());
    condition.setClinicId(treatment.getClinicId());
    condition.setDisciplineID(treatment.getDisciplineID());
    return condition;
}


export function getLocalizationText(teethLocalization: TeethLocalization) {
    if(!teethLocalization){
        return "";
    }

    let response:string[] = [];
    if(teethLocalization.nerve){response.push(("nerve"))}
    if(teethLocalization.mesial){response.push(("mesial"))}
    if(teethLocalization.distal){response.push(("distal"))}
    if(teethLocalization.lingual){response.push(("lingual"))}
    if(teethLocalization.vestibularBucal){response.push(("bucal"))}
    if(teethLocalization.apical){response.push(("apical"))}
    if(teethLocalization.cervicalCrown){response.push(("cervical crown"))}
    if(teethLocalization.cervicalRoot){response.push(("cervical root"))}
    if(teethLocalization.root){response.push(("root"))}
    if(teethLocalization.crown){response.push(("crown"))}
    if(teethLocalization.incisalOclusal){response.push(("incisial/oclusal"))}
    return response.join(", ");
}

export class BulkConditionStoreResponse {
    toothConditionResponseDTO: ToothConditionDTO;
    stomaInterventionResponseRequestDTO:InterventionModel;
}

export class BulkMouthConditionStoreResponse {
    mouthConditionResponseDTO: MouthConditionDTO;
    stomaInterventionResponseRequestDTO:InterventionModel;
}

export enum ToothSelectionMode{
    FULL="FULL",
    RANGE="RANGE",
    MAXILAR="MAXILAR",
    MANDIBULA="MANDIBULA",
    NONE="NONE",
    SINGLE="SINGLE"
}

